import {getNotificationPatterns, updateNotificationPattern} from "@services/notificationPatterns";

const fetch = (state) => {
	state.patternsLoading = true;
	return getNotificationPatterns().then(res => {
		state.patterns = [
			...res.data.items
		];
	}).finally(() => {
		state.patternsLoading = false;
	});
};

export default {
	state: {
		patterns: null,
		patternsLoading: false
	},

	actions: {
		async actionSaveNotificationPattern({state}, pattern) {
			state.patternsLoading = true;
			const dto = {
				id: pattern.id,
				type: pattern.type,
				channel: pattern.channel,
				enabled: pattern.enabled,
				subjectPattern: pattern.subjectPattern,
				messagePattern: pattern.messagePattern
			};
			return updateNotificationPattern(dto)
				.then(() => fetch(state))
				.catch((e => {
					state.patternsLoading = false;
					throw e;
				}));
		},

		async actionFetchNotificationPatterns({state}) {
			if (!state.patterns) {
				state.patterns = [];
				return fetch(state);
			}
		}
	},

	getters: {
		getterPatterns(state) {
			return () => state.patterns;
		},

		getterPatternsLoading(state) {
			return () => state.patternsLoading;
		}
	}
}
